var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckboxChecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#171C1E",
  d: "M0 4a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#checkbox-checked_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m14.715 7.74-5.852 6.117-3.577-3.577L6.92 8.646l1.907 1.907 4.218-4.41z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "checkbox-checked_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4 4h12v12H4z"
})))));
export { SvgCheckboxChecked as ReactComponent };